import Api from '../Api';

import { url } from './config';
import { Facility } from './types';

const api = new Api<Facility>(url);

export default api;
